module.exports = __webpack_public_path__ + "5f5a9b3b0fa661314a821c794f8a12f4.png";